import React from "react";

// Shared empty-state block: a faded outline icon over a title + optional hint.
// Used so "nothing here yet" reads as designed, not broken. Pass a lucide icon
// element. Keep the hint actionable — say what creates the first item.
export function EmptyState({
  icon,
  title,
  hint,
  action,
}: {
  icon: React.ReactNode;
  title: string;
  hint?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="empty-state" role="status">
      <div className="empty-state-icon" aria-hidden="true">{icon}</div>
      <strong className="empty-state-title">{title}</strong>
      {hint ? <span className="empty-state-hint">{hint}</span> : null}
      {action ? <div className="empty-state-action">{action}</div> : null}
    </div>
  );
}
